export default class ServiceOfferingDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { modifiedDate: new Date(json.modifiedDate), createdDate: new Date(json.createdDate) });
    }
}
